export const templateString = (text, variablesObject) => Object.keys(variablesObject)
    .reduce((acc, variableName) => {
    const placeholder = `{{${variableName}}}`;
    while (acc.includes(placeholder))
        acc = acc.replace(placeholder, variablesObject[variableName]);
    return acc;
}, text);
